import React, { useEffect, useState } from "react"
import { get, post } from "helpers/api_helper"
import { PROFILE_SETTINGS } from "helpers/url_helper"
import Notifications from "components/Notifications"

const OrderSettings = () => {
    const [data, setData] = useState({
        default_tat_days: 3,
        auto_jobcard: false,
        auto_labslip: false,
        redo_allowed: true,
        correction_allowed: true,
        auto_challan: false,
        default_correction_type: "manual",
        order_acknowledgement: false,
        allow_partial_delivery: false,
        order_edit_approval: true,
        invoice_edit_approval: true,
    });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => { fetchSettings(); }, [])

    const fetchSettings = async () => {
        setLoading(true);
        const res = await get(PROFILE_SETTINGS + "?type=orders");
        if (res.status === 200 && res.response && Object.keys(res.response).length > 0) {
            setData(prev => ({
                ...prev,
                ...res.response,
                order_edit_approval: res.response.order_edit_approval !== undefined
                    ? (res.response.order_edit_approval === true || res.response.order_edit_approval === "true" || res.response.order_edit_approval === 1 || res.response.order_edit_approval === "1")
                    : true,
                invoice_edit_approval: res.response.invoice_edit_approval !== undefined
                    ? (res.response.invoice_edit_approval === true || res.response.invoice_edit_approval === "true" || res.response.invoice_edit_approval === 1 || res.response.invoice_edit_approval === "1")
                    : (res.response.order_edit_approval !== undefined
                        ? (res.response.order_edit_approval === true || res.response.order_edit_approval === "true" || res.response.order_edit_approval === 1 || res.response.order_edit_approval === "1")
                        : true)
            }));
        }
        setLoading(false);
    }

    const saveSettings = async () => {
        setSaving(true);
        const res = await post(PROFILE_SETTINGS, { type: "orders", ...data });
        if (res.status === 200) Notifications("Order settings saved!", "success");
        else Notifications("Failed to save.", "error");
        setSaving(false);
    }

    const set = (key, val) => setData(prev => ({ ...prev, [key]: val }));
    const inp = { width:"100%", padding:"9px 12px", border:"1px solid #e2e8f0", borderRadius:"8px", fontSize:"13px", outline:"none", background:"#fff" };
    const lbl = { fontSize:"12px", fontWeight:"600", color:"#64748b", marginBottom:"5px", display:"block", textTransform:"uppercase", letterSpacing:"0.4px" };
    const box = { background:"#f8fafc", borderRadius:"10px", padding:"20px", marginBottom:"20px", border:"1px solid #e2e8f0" };

    const Toggle = ({ optKey, label, desc, badge }) => (
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 0", borderBottom:"1px solid #f1f5f9" }}>
            <div>
                <div style={{ fontWeight:"600", fontSize:"13px", color:"#1e293b", display:"flex", alignItems:"center", gap:"8px" }}>
                    {label}
                    {badge}
                </div>
                {desc && <div style={{ fontSize:"11px", color:"#94a3b8", marginTop:"2px" }}>{desc}</div>}
            </div>
            <div onClick={() => set(optKey, !data[optKey])} style={{ width:"44px", height:"24px", borderRadius:"12px", cursor:"pointer", background: data[optKey] ? "#2563eb" : "#cbd5e1", transition:"background 0.2s", position:"relative", flexShrink:0 }}>
                <div style={{ width:"18px", height:"18px", borderRadius:"50%", background:"#fff", position:"absolute", top:"3px", transition:"left 0.2s", left: data[optKey] ? "23px" : "3px", boxShadow:"0 1px 3px rgba(0,0,0,0.2)" }} />
            </div>
        </div>
    );

    if (loading) return <div style={{ textAlign:"center", padding:"40px" }}><i className="fas fa-spinner fa-spin text-primary" style={{ fontSize:"24px" }}></i><p style={{ marginTop:"10px", color:"#94a3b8", fontSize:"13px" }}>Loading...</p></div>;

    return (
        <div>
            <div style={box}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"16px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-time-five text-primary"></i> Turnaround Time (TAT)
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px" }}>
                    <div>
                        <label style={lbl}>Default TAT (days)</label>
                        <input type="number" min={1} max={30} style={inp} value={data.default_tat_days} onChange={e => set("default_tat_days", parseInt(e.target.value) || 1)} />
                        <div style={{ fontSize:"11px", color:"#94a3b8", marginTop:"4px" }}>Default delivery timeline for new orders</div>
                    </div>
                    <div>
                        <label style={lbl}>Default Correction Type</label>
                        <select style={inp} value={data.default_correction_type} onChange={e => set("default_correction_type", e.target.value)}>
                            <option value="manual">Manual</option>
                            <option value="redo">Redo</option>
                            <option value="adjustment">Adjustment</option>
                        </select>
                        <div style={{ fontSize:"11px", color:"#94a3b8", marginTop:"4px" }}>Default type when creating a correction</div>
                    </div>
                </div>
            </div>

            <div style={box}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"4px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-package text-primary"></i> Order Automations
                </div>
                <div style={{ fontSize:"11px", color:"#94a3b8", marginBottom:"16px" }}>These will auto-trigger when a new order is created</div>
                <Toggle optKey="auto_jobcard" label="Auto Generate Job Card" desc="Automatically create a job card when order is placed" />
                <Toggle optKey="auto_labslip" label="Auto Generate Lab Slip" desc="Automatically create a lab slip when order is placed" />
                <Toggle optKey="auto_challan" label="Auto Create Challan" desc="Automatically create a challan with the order" />
                <Toggle optKey="order_acknowledgement" label="Order Acknowledgement SMS/WhatsApp" desc="Send acknowledgement to client on order creation" />
            </div>

            <div style={{ ...box, marginBottom:"24px" }}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"4px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-shield-quarter text-primary"></i> Order Edit Approval & Permissions
                </div>
                <div style={{ fontSize:"11px", color:"#94a3b8", marginBottom:"16px" }}>Control edit approval workflows and global operational permissions</div>
                <Toggle
                    optKey="order_edit_approval"
                    label="Order Edit Approval Workflow"
                    desc="When turned on, non-admin users must request admin approval before editing orders. When turned off, users can edit directly without approval."
                    badge={
                        <span style={{
                            fontSize: "10px",
                            padding: "2px 8px",
                            borderRadius: "10px",
                            fontWeight: "600",
                            background: data.order_edit_approval ? "#dcfce7" : "#f1f5f9",
                            color: data.order_edit_approval ? "#15803d" : "#64748b"
                        }}>
                            {data.order_edit_approval ? "Active" : "Off"}
                        </span>
                    }
                />
                <Toggle
                    optKey="invoice_edit_approval"
                    label="Invoice Edit & Cancel Approval Workflow"
                    desc="When turned on, non-admin users must request admin approval before modifying or cancelling invoices. When turned off, users can modify and cancel invoices directly without approval."
                    badge={
                        <span style={{
                            fontSize: "10px",
                            padding: "2px 8px",
                            borderRadius: "10px",
                            fontWeight: "600",
                            background: data.invoice_edit_approval ? "#dcfce7" : "#f1f5f9",
                            color: data.invoice_edit_approval ? "#15803d" : "#64748b"
                        }}>
                            {data.invoice_edit_approval ? "Active" : "Off"}
                        </span>
                    }
                />
                <Toggle optKey="redo_allowed" label="Allow Redo Orders" desc="Allow users to mark orders for redo" />
                <Toggle optKey="correction_allowed" label="Allow Corrections" desc="Allow correction entries on completed orders" />
                <Toggle optKey="allow_partial_delivery" label="Allow Partial Delivery" desc="Allow orders to be partially delivered" />
            </div>

            <button onClick={saveSettings} disabled={saving} style={{ padding:"10px 24px", background:"#2563eb", color:"#fff", border:"none", borderRadius:"8px", fontWeight:"700", fontSize:"13px", cursor:"pointer", display:"flex", alignItems:"center", gap:"8px" }}>
                {saving ? <><i className="fas fa-spinner fa-spin" /> Saving...</> : <><i className="bx bx-save" /> Save Order Settings</>}
            </button>
        </div>
    );
}

export default OrderSettings;
